var _rect, _ellipse, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStakeButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.091,
    width: 24,
    height: 24,
    rx: 4,
    fill: "url(#a)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.091,
    cy: 9.342,
    rx: 6.255,
    ry: 2.741,
    fill: "#F4FFFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.087 11.3c-.768 1.132-3.162 1.957-5.996 1.957-2.833 0-5.227-.825-5.996-1.957-.168.248-.259.51-.259.783 0 1.513 2.8 2.74 6.255 2.74s6.255-1.227 6.255-2.74c0-.273-.09-.535-.259-.783z",
    fill: "#DDFEF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.087 13.875c-.768 1.133-3.162 1.958-5.996 1.958-2.833 0-5.227-.825-5.996-1.958a1.388 1.388 0 0 0-.259.783c0 1.514 2.8 2.741 6.255 2.741s6.255-1.227 6.255-2.74c0-.273-.09-.536-.259-.784z",
    fill: "#DDFEF0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 24.091,
    y1: 0,
    x2: -0.507,
    y2: 0.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAF5D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CE0D6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStakeButton);
export default __webpack_public_path__ + "static/media/stakeButton.a9dfa719a66d9c405368566e206385ba.svg";
export { ForwardRef as ReactComponent };